import { render, staticRenderFns } from "./ModalPeople.vue?vue&type=template&id=24d31339&"
import script from "./ModalPeople.vue?vue&type=script&lang=js&"
export * from "./ModalPeople.vue?vue&type=script&lang=js&"
import style0 from "./ModalPeople.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports